import { configureStore } from '@reduxjs/toolkit'
import authReducer from "./reducers/auth";
import configReducer from "./reducers/config";
import userReducer from "./reducers/user";
import embedActivityReducer from "./reducers/embed-activity";

export default configureStore({
  reducer: {
    auth          : authReducer
    ,config       : configReducer 
    ,user         : userReducer
    ,embedActivity : embedActivityReducer
  }
})